import React, { useEffect, useState, useRef } from 'react'
import ButtonWithSearch from '../../components/common/buttonWithSearch'
import { Paginator } from 'primereact/paginator';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import CommonModal from '../../components/common/commonModel';
import AddButtonSection from '../../components/common/AddButtonSection';
import "./userNotification.scss";
import DeleteIcon from '../../assets/images/DeleteIcon';
import InputComponent from '../../components/common/inputComponent';
import { commonPostApi } from '../../utils/apiService';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import { SORT_ORDER } from '../../constants/sortOrder';
import { convertToSearchField } from '../../utils/utils';
import Loader from '../../components/common/loader';
import { Checkbox } from 'primereact/checkbox';
import { COMMON_MSG, TOAST_TYPE } from '../../constants/toast';
import { showToast } from '../../components/common/toast';

const NotificationMenu = ({ item, onDelete }) => {
    const menuRef = useRef(null);

    // Styled delete button template, wired through PrimeReact Menu's click handler
    const itemRenderer = (menuItem, options) => (
        <div className="p-menuitem-content">
            {menuItem.label === 'Delete' && (
                <Button
                    className="card-button-delete"
                    label="Delete"
                    onClick={(e) => {
                        onDelete(item);
                        // Let PrimeReact handle closing / focus etc.
                        if (options && typeof options.onClick === 'function') {
                            options.onClick(e);
                        }
                    }}
                />
            )}
        </div>
    );

    const menuItems = [
        {
            label: 'Delete',
            icon: 'pi pi-trash',
            template: itemRenderer,
        },
    ];

    return (
        <React.Fragment>
            <div className="card flex justify-content-center">
                <Menu
                    model={menuItems}
                    popup
                    ref={menuRef}
                    id={`popup_menu_${item.notification_id ?? item.id}`}
                    popupAlignment="right"
                    appendTo={document.body}
                />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="plain-three-dots"
                    onClick={(event) => menuRef.current?.toggle(event)}
                    aria-controls={`popup_menu_${item.notification_id ?? item.id}`}
                    aria-haspopup
                />
            </div>
        </React.Fragment>
    );
};

const UserNotification = () => {
    const searchFields = ["notification_description"];
    const [loader, setLoading] = useState(true);
    const [count, SetCount] = useState(null)
    const selectedIdsRef = useRef([]);
    const [navigator, setNavigator] = useState({
        page: 1,
        first: 0,
        rows: 10,
        totalRecords: 1,
        sortBy: "updated_at",
        sortDir: SORT_ORDER.DESC,
        searchCriteria: convertToSearchField(searchFields, ""),
    });
    const [notification, setNotification] = useState([]);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [isBulkDelete, setIsBulkDelete] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);

    

    
    selectedIdsRef.current = selectedIds;
    const imageurl = (created_by) => {
        return `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(created_by)}`
    }

    const mask = (firstname, lastname) => {
        const Fname = firstname.charAt(0).toUpperCase();
        const Lname = lastname.charAt(0).toUpperCase();
        return Fname + Lname;
    }

    const getItemKey = (item) => item?.notification_id ?? item?.id;

    const init = async (navigatorState = navigator, autoSelectAll = false) => {
        let currentObj = {
            query: {
                page: navigatorState?.page,
                limit: navigatorState?.rows,
                sortFields: [[navigatorState?.sortBy || "created_at", navigatorState?.sortDir || SORT_ORDER.DESC]],
                searchCriteria: navigatorState?.searchCriteria,
            },
            // user_id: userDetails?.user_id
        };
        await commonPostApi(API_ENDPOINTS.GET_NOTIFICATION_BY_USER, currentObj)
            .then((response) => {
                const list = response?.data?.data || [];
                const newSelectedIds = [];
                const currentSelectedIds = selectedIdsRef.current;
                const mapped = list.map((item) => {
                    const key = getItemKey(item);
                    let checked = currentSelectedIds.includes(key);

                    if (autoSelectAll) {
                        checked = true;
                        if (key !== undefined && key !== null && !currentSelectedIds.includes(key)) {
                            newSelectedIds.push(key);
                        }
                    }

                    return {
                        ...item,
                        checked,
                    };
                });

                if (autoSelectAll && newSelectedIds.length) {
                    setSelectedIds((prev) => {
                        const merged = [...prev];
                        newSelectedIds.forEach((id) => {
                            if (!merged.includes(id)) {
                                merged.push(id);
                            }
                        });
                        return merged;
                    });
                }

                setNotification(mapped);
                SetCount(response.data?.total || 0)
                setNavigator((prev) => ({
                    ...prev,
                    totalRecords: response?.data?.total,
                    page: response?.data?.currentPage,
                }));
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false);
    }

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const deleteData = (item) => {
        setItemToDelete(item);
        setIsBulkDelete(false);
        setDeleteModalVisible(true);
    };


    const toggleCheck = (item) => {
        const id = getItemKey(item);
        setSelectedIds((prevSelected) => {
            const isSelected = prevSelected.includes(id);
            const newSelected = isSelected
                ? prevSelected.filter((selectedId) => selectedId !== id)
                : [...prevSelected, id];

            setNotification((prevNotification) =>
                prevNotification.map((x) =>
                    getItemKey(x) === id ? { ...x, checked: !isSelected } : x
                )
            );

            return newSelected;
        });
    };

    const allSelected = notification.length > 0 && notification.every((n) => n.checked);
    const someSelected = notification.some((n) => n.checked);

    const toggleSelectAll = () => {
        const currentPageIds = notification
            .map((item) => getItemKey(item))
            .filter((id) => id !== undefined && id !== null);

        if (allSelected) {
            // Unselect all on current page
            setSelectedIds((prevSelected) =>
                prevSelected.filter((id) => !currentPageIds.includes(id))
            );
            setNotification((prev) =>
                prev.map((item) =>
                    currentPageIds.includes(getItemKey(item))
                        ? { ...item, checked: false }
                        : item
                )
            );
        } else {
            // Select all on current page (merge with existing selection from other pages)
            setSelectedIds((prevSelected) => {
                const newSelected = [...prevSelected];
                currentPageIds.forEach((id) => {
                    if (!newSelected.includes(id)) {
                        newSelected.push(id);
                    }
                });
                return newSelected;
            });
            setNotification((prev) =>
                prev.map((item) =>
                    currentPageIds.includes(getItemKey(item))
                        ? { ...item, checked: true }
                        : item
                )
            );
        }
    };

    const deleteSelected = () => {
        const selectedItems = notification.filter((x) => x.checked);
        console.log('Bulk delete icon clicked. Selected items:', selectedItems);
        setItemToDelete(null);
        setIsBulkDelete(true);
        setDeleteModalVisible(true);
    };

    const getNotificationUserIdsForItem = (item) => {
        if (!item) return [];

        const assocIds = Array.isArray(item.userAssociations)
            ? item.userAssociations
                .map((ua) => ua?.notification_user_id)
                .filter(Boolean)
            : [];

        if (assocIds.length) {
            console.log('Resolved notification_user_ids from userAssociations:', assocIds, 'for item:', item);
            return assocIds;
        }

        const fallbackId =
            item.notification_user_id ??
            item.notificationUserId ??
            item.notification_id ??
            item.id ??
            null;

        const result = fallbackId ? [fallbackId] : [];
        console.log('Resolved fallback notification_user_ids:', result, 'for item:', item);
        return result;
    };

    const handleConfirmDelete = async () => {
        try {
            const ids = isBulkDelete
                ? notification
                    .filter((x) => x.checked)
                    .flatMap((x) => getNotificationUserIdsForItem(x))
                    .filter(Boolean)
                : itemToDelete
                    ? getNotificationUserIdsForItem(itemToDelete)
                    : [];

            console.log('Confirm delete clicked. isBulkDelete:', isBulkDelete, 'itemToDelete:', itemToDelete);
            console.log('Delete payload notification_user_ids:', ids);

            if (!ids.length) {
                showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.SELECT_RECORDS);
                console.warn('No notification_user_ids to delete. Aborting delete call.');
                return;
            }

            setLoading(true);

            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            const res = await commonPostApi(
                API_ENDPOINTS.DELETE_NOTIFICATION_USER,
                { notification_user_ids: ids },
                headers
            );

            console.log('Delete notification user response:', res);

            if (res?.status === 200 || res?.status === 201) {
                // Remove deleted ids from selectedIds so count decreases
                const keysToRemove = isBulkDelete
                    ? notification.filter((x) => x.checked).map((x) => getItemKey(x)).filter((id) => id != null)
                    : itemToDelete ? [getItemKey(itemToDelete)] : [];
                setSelectedIds((prev) => prev.filter((id) => !keysToRemove.includes(id)));

                showToast(TOAST_TYPE.SUCCESS, COMMON_MSG.SUCCESS.DELETED);
                // Refresh notifications from server after delete
                await init({
                    ...navigator,
                    // keep current page/first as-is so UX stays on same page
                });
            } else {
                showToast(
                    TOAST_TYPE.ERROR,
                    res?.data?.message || COMMON_MSG.ERROR.GENERIC
                );
            }
        } catch (error) {
            console.error('Delete Notification User Error:', error);
            showToast(
                TOAST_TYPE.ERROR,
                error?.response?.data?.message || COMMON_MSG.ERROR.GENERIC
            );
        } finally {
            setDeleteModalVisible(false);
            setItemToDelete(null);
            setIsBulkDelete(false);
        }
    };

    const submitButtons = [
        {
            type: "primarySuccessButton",
            label: "Yes",
            class: "w-8rem pr-3",
            onClick: handleConfirmDelete,
        },
        {
            type: "secondaryButton",
            label: "No",
            class: "w-7rem",
            onClick: () => {
                setDeleteModalVisible(false);
                setItemToDelete(null);
                setIsBulkDelete(false);
            },
        },
    ];

    const handleSeachChange = (value) => {
        setNavigator((prev) => ({
            ...prev,
            searchCriteria: convertToSearchField(searchFields, value),
        }));
        init({
            ...navigator,
            searchCriteria: convertToSearchField(searchFields, value),
        }, false);
    }

    const onRowCountChange = (e) => {
        setLoading(true);
        setNavigator((prev) => ({
            ...prev,
            rows: e?.target?.value,
            page: 1,
            first: 0,
        }));
        init({
            ...navigator,
            page: 1,
            first: 0,
            rows: e?.target?.value,
        }, false);
    };

    function onPageChange(event) {
        setLoading(true);
        setNavigator((prev) => ({
            ...prev,
            first: event?.first,
            page: event.page + 1,
        }));
        init({
            ...navigator,
            first: event?.first,
            page: event.page + 1,
        }, false);

    }

    const leftContent = (e) => {
        const first = Number.isFinite(e?.first) ? e.first : 0;
        const rows = Number.isFinite(e?.rows) ? e.rows : 0;
        const total = Number.isFinite(e?.totalRecords) ? e.totalRecords : 0;
        const currentMax = first + rows;
        return (
            <div className="flex rc-patient-flex">
                <div className="rc-patient-option-rows" style={{ position: 'relative', zIndex: 9999 }}>
                    <InputComponent
                        type="dropdown-std"
                        placeholder="select a range"
                        options={[5, 10, 25, 50, 100].map((n) => ({ label: String(n), value: n }))}
                        value={navigator?.rows || 1}
                        onChange={onRowCountChange}
                    />
                </div>
                <span className="pl-3 text-commonConten public_sans_400 text-15px flex align-items-center">
                    {`Showing ${Math.min(first + 1, Math.max(total, 1))} - ${Math.min(
                        currentMax,
                        total
                    )} of ${total}`}
                </span>
            </div>
        );
    };

    if (loader) {
        return <Loader />;
    }

    return (
        <div className="user-notification-container">
            <ButtonWithSearch
                searchHeaderLable={`${selectedIds.length} Notifications`}
                searchHeaderLeftContent={
                    notification.length > 0 ? (
                        <div className="flex align-items-center gap-2">
                            <Checkbox
                                checked={allSelected}
                                indeterminate={someSelected && !allSelected}
                                onChange={toggleSelectAll}
                                title="Select all"
                            />
                            {someSelected && (
                                <span
                                    role="button"
                                    tabIndex={0}
                                    className="flex align-items-center cursor-pointer px-1"
                                    onClick={deleteSelected}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); deleteSelected(); } }}
                                    title="Delete selected"
                                >
                                    <DeleteIcon />
                                </span>
                            )}
                        </div>
                    ) : null
                }
                searchPlaceHolder={"Search Users"}
                isSearchEnabled={true}
                isCalenderEnabled={false}
                isButtonEnabledLeft={false}
                isButtonEnabledRight={false}
                onChange={handleSeachChange}
            />

            {notification.length > 0 ? notification?.map((item) => (
                <div className="Notificationmain" key={item.notification_id ?? item.id}>
                    <div className='Notificationcontainer'>
                        <div className="Notificationbody">
                            <div className="Notificationside">
                                <div className='Notificationcheckbox'>
                                    <Checkbox
                                        checked={item.checked || false}
                                        onChange={() => toggleCheck(item)}
                                    />
                                </div>
                                <div className='Notificationlogo'>
                                    <div>
                                        {
                                            item?.creator?.profile_picture ?
                                                <img
                                                    className="Notificationlogo-circle"
                                                    src={imageurl(item.created_by)}
                                                    alt="userProfile"
                                                /> :
                                                <span className="Notification-avatar-initials">{mask(item?.creator.first_name, item?.creator?.last_name)}</span>
                                        }

                                    </div>

                                </div>
                            </div>
                            <div className='Notificationcontent'>
                                <div className='Notificationdescription'>
                                    <span>{item.notification_description}</span>
                                </div>
                                <div className='NotificationDate'>
                                    <span className='NotificationDateContent'>
                                        Oct 29, 2025
                                    </span>
                                </div>
                            </div>
                            <div className='Notificationdelete'>
                                <NotificationMenu item={item} onDelete={deleteData} />
                            </div>
                        </div>
                    </div>

                </div>
            )) : <p>No Notification Found</p>}

            <Paginator
                leftContent={leftContent}
                first={navigator?.first || 0}
                rows={navigator?.rows || 1}
                totalRecords={navigator?.totalRecords || 1}
                onPageChange={onPageChange}
            />

            <CommonModal
                visible={deleteModalVisible}
                header={COMMON_MSG.CONFIRM.CONFIRMATION_HEADER}
                onHide={() => {
                    setDeleteModalVisible(false);
                    setItemToDelete(null);
                    setIsBulkDelete(false);
                }}
            >
                <div>
                    <div className="flex justify-content-center pr-4">
                        {COMMON_MSG.CONFIRM.DELETE_NOTIFICATION}
                    </div>

                    <div className="mt-6 ml-2">
                        <AddButtonSection buttons={submitButtons} />
                    </div>
                </div>
            </CommonModal>
        </div>
    )
}

export default UserNotification